var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-pm-dataQuery-tree"},[_c('ejs-treeview',{ref:"measureTreeForNoRealQuery",attrs:{"fields":_vm.fields,"nodeSelected":_vm.nodeSelectedOfMeasureTreeForNoRealQuery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }